// unless specified, all values are in mm
import { applicationSettings } from './application';

export default {
  ROOM_DEPTH: 1000,
  IRW_IFRAME_HEIGHT: 640, //pixels

  KIOSK_SCALING_PERCENTAGE: 125,

  INITIAL_VIEW: 'INITIAL_VIEW',
  VIEW_NAMES: {
    START: 'START',
    SCENE: 'SCENE',
    SUMMARY: 'SUMMARY',
  },

  OFFSET_BOTTOM_ATTACHMENT: 50,
  OFFSET_TOP_ATTACHMENT: 50,

  NBR_OF_ATTACHMENTS: {
    1100: 6,
    1900: 10,
  },
  SKIRT_HEIGHT: 50,

  OBLIQUE_ANGLE: 27 * (Math.PI / 180),

  MEASUREMENTS_OFFSET: 4, //pixels
  MEASUREMENTS_OFFSET_KIOSK: 8, //pixels
  MEASUREMENTS_OFFSET_MOBILE: 4, //pixels
  MEASUREMENTS_LINE_SERIF: 50, //mm, I think.

  CROSS_BRACE_DIMENSIONS: {
    650: {
      height: 820,
      width: 630,
    },

    850: {
      height: 625,
      width: 825,
    },
  },

  /*
NB don't just add next drag mode as 5
since we rely on bitwise operations here, so MIXED is INSERT | FLOAT
*/
  DRAG_MODE: {
    INSERT: 1,
    FLOAT: 2,
    MIXED: 3,
    MULTI: 4,
  },

  SCREENSAVER_MODE: {
    idle: 'idle',
    slideshow: 'slideshow',
    countdown: 'countdown',
  },

  SESSION_STORAGE: {
    LANGUAGE_PICKER_ACTIVE_VIEW_KEY: 'LANGUAGE_PICKER_ACTIVE_VIEW_KEY',
    CHECKOUT_IMAGE_CACHE_KEY: 'CHECKOUT_IMAGE_CACHE_KEY',
  },

  // TODO this should roughly be 20 pixels (from UX designs) in IRW
  DROP_AREA_MAX_HEIGHT: 107,
  // and this would be half of that.
  DROP_AREA_MIN_HEIGHT: 64,
  DROP_AREA_SEPARATION: 0.1,

  IMAGE_ROOT: `./images/${applicationSettings.applicationName.toLowerCase()}/`,
  START_FROM_SCRATCH_IMAGE_FILENAME: 'custom_start_scratch.jpg',
  MOUNTING_RAIL_SAFETY_INSTRUCTIONS: 'mounting_rail_safety_instructions.png',
  AURDAL_GOOD_TO_KNOW_DRAWERS_IMAGE: 'good_to_know_drawers_aurdal.jpg',

  SERIES_GALLERY_ACTIVE_KEY: 'SERIES_GALLERY_ACTIVE_KEY',

  DEFAULT_TRANSPARENCY_ALPHA: 0.4,

  VERTEX_ROUNDING_PRECISION: 0.0001,

  OUTLINE_PADDING: 10,
  OUTLINE_PADDING_MOBILE_PORTRAIT: 5,

  // Thickness (before scaling) of any skirt edge regardless of which wall/sidewall it is.
  SKIRT_EDGE_THICKNESS: 8,

  SKIRT_COLOR: 0xebebeb,
  SKIRT_EDGE_COLOR: 0xcbcbc2,
  GRADIENT_LIGHT_COLOR: 0xccccc6,
  GRADIENT_DARK_COLOR: 0xb9b9b1,
  SIDEWALL_SKIRT_COLOR: 0xc3c3c3,
  SIDEWALL_SKIRT_EDGE_COLOR: 0xd6d6d6,
  SIDEWALL_GRADIENT_LIGHT_COLOR: 0xc4c4bd,
  SIDEWALL_GRADIENT_DARK_COLOR: 0xb9b9b1,
  RIGHT_SIDEWALL_SKIRT_COLOR: 0xebebeb,
  RIGHT_SIDEWALL_SKIRT_EDGE_COLOR: 0xd6d6d6,

  WALL_GRADIENT_ANGLE: 11,
  SIDEWALL_GRADIENT_ANGLE: 0,
};
